import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_PRODUCT_COST_BY_LAST_PURCHASE = '[PRODUCT PRICES] GET PRODUCT COST BY LAST PURCHASE'

export function getProductCostByLastPurchasesAction(productId) {
  const request = api.get(`/product-cost/by-last-purchases/${productId}`)
  return (dispatch) => {
    dispatch({ type: GET_PRODUCT_COST_BY_LAST_PURCHASE, payload: { loading: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        dispatch({ type: GET_PRODUCT_COST_BY_LAST_PURCHASE, payload: { data: {} } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_PRODUCT_COST_BY_LAST_PURCHASE, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener el costo del producto")
      console.log(GET_PRODUCT_COST_BY_LAST_PURCHASE, error)
    }).finally(() => {
      dispatch({ type: GET_PRODUCT_COST_BY_LAST_PURCHASE, payload: { loading: false } })
    })
  }
}
